import { ICompileService } from "angular";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  ColumnDefinitionSetServiceProvider,
  vsServiceName as ColumnDefinitionSetServiceName,
  vsProviderName as ColumnDefinitionServiceProviderName,
  ColumnDefinitionSetService,
} from "../../../records/grids/columns/columnDefinitionSetService";
import {
  RecordGridViewService,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
  vsServiceName as RecordGridViewServiceName,
} from "../../../records/views/recordGridView";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import { FilterProvider } from "../../../records/grids/columns/filters/FilterProvider";

import { OptionsFilter } from "../../../records/grids/columns/filters/subFilters/OptionsFilter";
import {
  moneyValueGetterFactory,
  percentageValueGetterFactory,
} from "../../../records/grids/cells/valueGetters";
import { machineConfigurationObjectName } from "../../shared/names";
import { RecordDataSource } from "../../../records/grids";

export const vsObjectName = "machineProgressiveLevel";

export function machineProgressiveLevelConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  recordGridViewServiceProvider.addGridConfiguration(vsObjectName, [
    ServerUtilityName,
    GridSettingsServiceName,
    RecordGridViewServiceName,
    (
      serverUtility: ServerUtility,
      gridSettingsService: GridSettingsService,
      recordGridViewService: RecordGridViewService
    ) => {
      const machineConfigurationGridConfig =
        recordGridViewService.getGridConfiguration(
          machineConfigurationObjectName
        );

      return {
        columnDefinitionSet: vsObjectName,
        defaultSort: RecordGridViewService.combineSort(
          machineConfigurationGridConfig?.defaultSort,
          "Order"
        ),
        gridDataSource: new RecordDataSource(
          serverUtility,
          "/api/machines/MachineProgressiveLevel"
        ),
        gridSettings: gridSettingsService.getGridSettings(Symbol(vsObjectName)),
        namePlural: "Machine Progressive Level Configurations",
        nameSingular: "Machine Progressive Level Configuration",
        showAddButton: false,
      };
    },
  ]);

  columnDefinitionSetServiceProvider.addColumnDefinitionSet(vsObjectName, [
    ColumnDefinitionServiceName,
    "$compile",
    ColumnDefinitionSetServiceName,
    (
      columnDefinitionService: ColumnDefinitionService,
      $compile: ICompileService,
      columnDefinitionSetService: ColumnDefinitionSetService
    ) => [
      columnDefinitionService.getNumberColDef({
        field: "Id",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "MachineConfigurationId",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "ResetValue",
        header: "Reset Value",
        valueGetter: moneyValueGetterFactory({ decimalPlaces: 2 }),
      }),
      columnDefinitionService.getNumberColDef({
        field: "IncrementRate",
        header: "Increment Rate",
        valueGetter: percentageValueGetterFactory({ decimalPlaces: 2 }),
      }),
      columnDefinitionService.getStringColDef({
        field: "ProgressiveType",
        header: "Progressive Type",
        filter: new FilterProvider("ProgressiveType", $compile)
          .addFilter(
            "=",
            new OptionsFilter({
              displayName: "=",
              queryFieldNames: ["ProgressiveType"],
              options: [
                {
                  display: "Linked",
                  value: "Linked",
                },
                {
                  display: "Standalone",
                  value: "Standalone",
                },
                {
                  display: "WAP",
                  value: "WAP",
                },
              ],
            })
          )
          .getGridFilterFactory(),
      }),
      columnDefinitionService.getStringColDef({
        field: "MachineDenominationName",
        header: "Denomination",
      }),
      ...columnDefinitionSetService.getColumnDefinitionSet(
        machineConfigurationObjectName
      ),
    ],
  ]);
}
machineProgressiveLevelConfig.$inject = [
  RecordGridViewServiceProviderName,
  ColumnDefinitionServiceProviderName,
];
